"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const NetworkNodeValidation_1 = require("../validations/NetworkNodeValidation");
class NetworkScanNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.NETWORK };
    if (props.type !== types_1.NODE_TYPES.NETWORK)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData) {
      nodeData = {
        cidr: "",
        proxy: ""
      };
    }
    return { cidr: nodeData.cidr };
  }
  serialize(uiData) {
    return { ...uiData, proxy: ":credentials" };
  }
  async getAvailableResources() {
    let availableResources = [];
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label: [this.getNodeName(), "Devices"].join("."),
      context: {
        outputPath: ""
      }
    });
    return availableResources;
  }
  validate() {
    return new NetworkNodeValidation_1.NetworkNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.NetworkScanNode = NetworkScanNode;
//# sourceMappingURL=NetworkNode.js.map
